/**
 * Object required for the move functions -- contains state between dragStart and dragEnd.
 * Now holds all primitives.
 * Left as non literal for future flexibility
 * TODO: now maybe some overlap with the shapeTransform model
 * A lot of intertwined with existing ShapeMoveFns -- could be cleaned-up
 */


var DragHelper = function( options ) {

    this.canvasBounds = options.canvasBounds
        ? options.canvasBounds
        : null;

    this.isTransformedShape = options.isTransformedShape;

    this.preventDragOffCanvas = typeof options.preventDragOffCanvas !== 'undefined'
        ? options.preventDragOffCanvas
        : true;

    if ( this.isTransformedShape ) {

        // ---> used to calc dx, dy for inv matrix adjustment
        this.pageScale = options.pageScale ? options.pageScale : 1.0;
        this.pageRotation = options.pageRotation ? options.pageRotation : 0;
        this.pageTransform = options.pageTransform ? options.pageTransform : '';

    }

    this.dragOpacity = options.dragOpacity ? options.dragOpacity : 1; // ( also serves as flag to change opacity on drag )
    this.originalOpacity = 1; // set on move start from el

    this.obox = null;
    this.obx = 0;
    this.oby = 0;

    /* Adjusted dx, dy from moveMove taking boundaries into account */
    this.dx = 0;
    this.dy = 0;

    /* Set on move end for this.isTransformedShape */
    this.invmDx = 0;
    this.invmDy = 0;

    /* - callbacks: -- not implementing here now .... */
        //- onAfterMoveStart
        //- onAfterMove
        //- onAfterMoveEnd


};




_.extend( DragHelper.prototype, {

    getPreventDragOffCanvas: function() {

        return this.preventDragOffCanvas;

    }


} );


// For now since only primitives, no need for destroy



module.exports = DragHelper;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/moveFns/dragHelper.js
 ** module id = 191
 ** module chunks = 0
 **/